<app-hero />
<app-pain-points />
<app-modules />
<app-platform-gallery />
<app-governance />
<app-audit-resources />
<app-faq />
<app-demo-request />
